// Drawer domain slice.
//
// `isUserScrolledToBottom` changes on every scroll event, so it lives in the store
// (selected via useDrawerStore) rather than the context value — only the one
// component that selects it (ScrollToBottomButton) re-renders while scrolling. The
// slice keeps flat state (Zustand-idiomatic) so a store built from it exposes the
// field at the top level.
export const drawerSlice = (set) => ({
  isUserScrolledToBottom: false,
  setScrolledToBottom: (isAtBottom) => set({ isUserScrolledToBottom: isAtBottom }),
});
